module.exports = __webpack_public_path__ + "media/images/home/logo-clutter-dark-f3bb5c01de6d0fc1e6f3f80fdf37d756.svg";